import React from "react"
import { Link } from "react-router-dom"
import useDropdownToggle from "../hooks/useDropdownToggle"

const Header = () => {
    useDropdownToggle(); // Initialize dropdown functionality
    
    return (
            <div
  className="nk-sidebar is-light nk-sidebar-fixed "
  data-content="sidebarMenu"
>
  <div className="nk-sidebar-element nk-sidebar-head">
    <div className="nk-sidebar-brand">
      <Link to="/dashboard" className="logo-link nk-sidebar-logo">
        <img
          className="logo-light logo-img"
          src="/assets/images/wg_logo.png"
          srcSet="./assets/images/wg_logo.png 2x"
          alt="logo"
        />
        <img
          className="logo-dark logo-img"
          src="/assets/images/wg_logo.png"
          srcSet="/assets/images/wg_logo.png 2x"
          alt="logo-dark"
        />
        <img
          className="logo-small logo-img logo-img-small"
          src="/assets/images/wg_logo.png"
          srcSet="/assets/images/wg_logo.png 2x"
          alt="logo-small"
        />
      </Link>
    </div>
    <div className="nk-menu-trigger me-n2">
      <button
        type="button"
        className="nk-nav-toggle nk-quick-nav-icon d-xl-none"
        data-target="sidebarMenu"
      >
        <em className="icon ni ni-arrow-left" />
      </button>
    </div>
  </div>
  <div className="nk-sidebar-element">
    <div className="nk-sidebar-content">
      <div className="nk-sidebar-menu" data-simplebar="">
        <ul className="nk-menu">
          <li className="nk-menu-heading">
            <h6 className="overline-title text-primary-alt">
              Home
            </h6>
          </li>
          <li className="nk-menu-item">
            <Link to="/dashboard" className="nk-menu-link">
              <span className="nk-menu-icon">
                <em className="icon ni ni-bag" />
              </span>
              <span className="nk-menu-text">Dashboard</span>
              <span className="nk-menu-badge">20</span>
            </Link>
          </li>
         
          <li className="nk-menu-heading">
            <h6 className="overline-title text-primary-alt">Campaign Points</h6>
          </li>
          <li className="nk-menu-item has-sub">
            <Link to="/stores" className="nk-menu-link nk-menu-toggle">
              <span className="nk-menu-icon">
                <em className="icon ni ni-tile-thumb" />
              </span>
              <span className="nk-menu-text">Stores</span>
            </Link>
            <ul className="nk-menu-sub">
              <li className="nk-menu-item">
                <Link to="/stores" className="nk-menu-link">
                  <span className="nk-menu-text">Participants</span>
                </Link>
              </li>
              <li className="nk-menu-item">
                <Link to="/offline-stores" className="nk-menu-link">
                  <span className="nk-menu-text">Non-participants</span>
                </Link>
              </li>
            </ul>
          </li>
  
          <li className="nk-menu-item has-sub">
            <Link to="/users" className="nk-menu-link nk-menu-toggle">
              <span className="nk-menu-icon">
                <em className="icon ni ni-user-list" />
              </span>
              <span className="nk-menu-text">Customers</span>
            </Link>
            <ul className="nk-menu-sub">
              <li className="nk-menu-item">
                <Link to="/users" className="nk-menu-link">
                  <span className="nk-menu-text">Customer List</span>
                </Link>
              </li>
              <li className="nk-menu-item">
                <Link to="/winners" className="nk-menu-link">
                  <span className="nk-menu-text">Winners</span>
                </Link>
              </li>
            </ul>
          </li>
          <li className="nk-menu-item has-sub">
            <Link to="/all-transactions" className="nk-menu-link nk-menu-toggle">
              <span className="nk-menu-icon">
                <em className="icon ni ni-tranx" />
              </span>
              <span className="nk-menu-text">Transactions</span>
            </Link>
            <ul className="nk-menu-sub">
              <li className="nk-menu-item">
                <Link to="/all-transactions" className="nk-menu-link">
                  <span className="nk-menu-text">All</span>
                </Link>
              </li>
              <li className="nk-menu-item">
                <Link
                  to="/approved-transactions"
                  className="nk-menu-link"
                >
                  <span className="nk-menu-text">Approved</span>
                </Link>
              </li>
              <li className="nk-menu-item">
                <Link
                  to="/pending-transactions"
                  className="nk-menu-link"
                >
                  <span className="nk-menu-text">Pending</span>
                </Link>
              </li>
              <li className="nk-menu-item">
                <Link
                  to="/rejected-transactions"
                  className="nk-menu-link"
                >
                  <span className="nk-menu-text">Rejected</span>
                </Link>
              </li>
            </ul>
          </li>
          
        </ul>
      </div>
    </div>
  </div>
</div>

        )
}

export default Header